// Country codes with flag icons mapping
const countryCodes = [
    { code: '+1', country: 'US', name: 'United States', flag: '🇺🇸' },
    { code: '+7', country: 'RU', name: 'Russia', flag: '🇷🇺' },
    { code: '+20', country: 'EG', name: 'Egypt', flag: '🇪🇬' },
    { code: '+27', country: 'ZA', name: 'South Africa', flag: '🇿🇦' },
    { code: '+31', country: 'NL', name: 'Netherlands', flag: '🇳🇱' },
    { code: '+32', country: 'BE', name: 'Belgium', flag: '🇧🇪' },
    { code: '+33', country: 'FR', name: 'France', flag: '🇫🇷' },
    { code: '+34', country: 'ES', name: 'Spain', flag: '🇪🇸' },
    { code: '+39', country: 'IT', name: 'Italy', flag: '🇮🇹' },
    { code: '+41', country: 'CH', name: 'Switzerland', flag: '🇨🇭' },
    { code: '+43', country: 'AT', name: 'Austria', flag: '🇦🇹' },
    { code: '+44', country: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
    { code: '+45', country: 'DK', name: 'Denmark', flag: '🇩🇰' },
    { code: '+46', country: 'SE', name: 'Sweden', flag: '🇸🇪' },
    { code: '+47', country: 'NO', name: 'Norway', flag: '🇳🇴' },
    { code: '+52', country: 'MX', name: 'Mexico', flag: '🇲🇽' },
    { code: '+55', country: 'BR', name: 'Brazil', flag: '🇧🇷' },
    { code: '+60', country: 'MY', name: 'Malaysia', flag: '🇲🇾' },
    { code: '+61', country: 'AU', name: 'Australia', flag: '🇦🇺' },
    { code: '+62', country: 'ID', name: 'Indonesia', flag: '🇮🇩' },
    { code: '+63', country: 'PH', name: 'Philippines', flag: '🇵🇭' },
    { code: '+64', country: 'NZ', name: 'New Zealand', flag: '🇳🇿' },
    { code: '+65', country: 'SG', name: 'Singapore', flag: '🇸🇬' },
    { code: '+66', country: 'TH', name: 'Thailand', flag: '🇹🇭' },
    { code: '+81', country: 'JP', name: 'Japan', flag: '🇯🇵' },
    { code: '+82', country: 'KR', name: 'South Korea', flag: '🇰🇷' },
    { code: '+84', country: 'VN', name: 'Vietnam', flag: '🇻🇳' },
    { code: '+86', country: 'CN', name: 'China', flag: '🇨🇳' },
    { code: '+91', country: 'IN', name: 'India', flag: '🇮🇳' },
    { code: '+358', country: 'FI', name: 'Finland', flag: '🇫🇮' },
    { code: '+966', country: 'SA', name: 'Saudi Arabia', flag: '🇸🇦' },
    { code: '+971', country: 'AE', name: 'United Arab Emirates', flag: '🇦🇪' }
];

// Function to populate country code select dropdown
function populateCountryCodeSelect(selectElement, defaultOptionText = 'Select Code') {
    if (!selectElement) return;
    
    // Clear existing options
    selectElement.innerHTML = '';
    
    // Add default option
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = defaultOptionText;
    selectElement.appendChild(defaultOption);
    
    // Add country options
    countryCodes.forEach(country => {
        const option = document.createElement('option');
        option.value = country.code;
        
        // Use emoji flag with country code - this works in select options
        option.textContent = `${country.flag} ${country.code}`;
        
        // Set US as default selected
        if (country.code === '+1') {
            option.selected = true;
        }
        
        selectElement.appendChild(option);
    });
}

// Alternative function to create a custom dropdown with flag icons
function createCustomCountryDropdown(selectElement, defaultOptionText = 'Select Code') {
    if (!selectElement) return;
    
    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'custom-country-dropdown';
    wrapper.style.position = 'relative';
    wrapper.style.display = 'inline-block';
    wrapper.style.width = '100%';
    
    // Create the display button
    const displayButton = document.createElement('button');
    displayButton.type = 'button';
    displayButton.className = 'form-control form-select custom-dropdown-button';
    displayButton.style.textAlign = 'left';
    displayButton.style.cursor = 'pointer';
    displayButton.style.display = 'flex';
    displayButton.style.alignItems = 'center';
    displayButton.innerHTML = `<span class="fi fi-us" style="margin-right: 8px;"></span>+1`;
    
    // Create hidden input to store the selected value
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = selectElement.name;
    hiddenInput.value = '+1'; // Default to US
    
    // Create a fake select element that mimics the original for compatibility
    const fakeSelect = document.createElement('select');
    fakeSelect.id = selectElement.id;
    fakeSelect.name = selectElement.name;
    fakeSelect.className = selectElement.className; // Copy original classes
    fakeSelect.style.display = 'none';
    fakeSelect.value = '+1'; // Default to US
    
    // Copy all attributes from the original select
    Array.from(selectElement.attributes).forEach(attr => {
        if (attr.name !== 'id' && attr.name !== 'name') {
            fakeSelect.setAttribute(attr.name, attr.value);
        }
    });
    
    // Add options to the fake select
    const emptyOption = document.createElement('option');
    emptyOption.value = '';
    emptyOption.textContent = defaultOptionText;
    fakeSelect.appendChild(emptyOption);
    
    const fakeOption = document.createElement('option');
    fakeOption.value = '+1';
    fakeOption.selected = true;
    fakeSelect.appendChild(fakeOption);
    
    // Store references to options for later use
    const options = { empty: emptyOption, default: fakeOption };
    
    // Create dropdown list
    const dropdownList = document.createElement('div');
    dropdownList.className = 'custom-dropdown-list';
    dropdownList.style.display = 'none';
    dropdownList.style.position = 'absolute';
    dropdownList.style.top = '100%';
    dropdownList.style.left = '0';
    dropdownList.style.right = '0';
    dropdownList.style.backgroundColor = 'white';
    dropdownList.style.border = '1px solid #ced4da';
    dropdownList.style.borderTop = 'none';
    dropdownList.style.borderRadius = '0 0 0.375rem 0.375rem';
    dropdownList.style.maxHeight = '200px';
    dropdownList.style.overflowY = 'auto';
    dropdownList.style.zIndex = '1000';
    
    // Add default option
    const defaultItem = document.createElement('div');
    defaultItem.className = 'dropdown-item';
    defaultItem.style.padding = '8px 12px';
    defaultItem.style.cursor = 'pointer';
    defaultItem.style.borderBottom = '1px solid #e9ecef';
    defaultItem.textContent = defaultOptionText;
    defaultItem.addEventListener('click', function() {
        hiddenInput.value = '';
        fakeSelect.value = '';
        options.empty.selected = true;
        options.default.selected = false;
        displayButton.innerHTML = defaultOptionText;
        dropdownList.style.display = 'none';
        
        // Debug: Log the selected value
        console.log('Default option selected, fake select value:', fakeSelect.value);
        
        // Trigger change event for compatibility
        fakeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
    dropdownList.appendChild(defaultItem);
    
    // Add country options
    countryCodes.forEach(country => {
        const item = document.createElement('div');
        item.className = 'dropdown-item';
        item.style.padding = '8px 12px';
        item.style.cursor = 'pointer';
        item.style.borderBottom = '1px solid #e9ecef';
        item.style.display = 'flex';
        item.style.alignItems = 'center';
        item.innerHTML = `<span class="fi fi-${country.country.toLowerCase()}" style="margin-right: 8px;"></span>${country.code}`;
        
        item.addEventListener('click', function() {
            hiddenInput.value = country.code;
            
            // Update the default option to match the selected country
            options.default.value = country.code;
            options.default.textContent = country.code;
            
            // Select the country option
            options.empty.selected = false;
            options.default.selected = true;
            fakeSelect.value = country.code;
            
            displayButton.innerHTML = `<span class="fi fi-${country.country.toLowerCase()}" style="margin-right: 8px;"></span>${country.code}`;
            dropdownList.style.display = 'none';
            
            // Debug: Log the selected value
            console.log('Country selected:', country.code, 'Fake select value:', fakeSelect.value);
            
            // Trigger change event for compatibility
            fakeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
        
        item.addEventListener('mouseenter', function() {
            this.style.backgroundColor = '#f8f9fa';
        });
        
        item.addEventListener('mouseleave', function() {
            this.style.backgroundColor = 'white';
        });
        
        dropdownList.appendChild(item);
    });
    
    // Toggle dropdown
    displayButton.addEventListener('click', function(e) {
        e.preventDefault();
        dropdownList.style.display = dropdownList.style.display === 'none' ? 'block' : 'none';
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
        if (!wrapper.contains(e.target)) {
            dropdownList.style.display = 'none';
        }
    });
    
    // Assemble the custom dropdown
    wrapper.appendChild(displayButton);
    wrapper.appendChild(hiddenInput);
    wrapper.appendChild(fakeSelect);
    wrapper.appendChild(dropdownList);
    
    // Replace the original select
    selectElement.parentNode.replaceChild(wrapper, selectElement);
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    const areaCodeSelect = document.getElementById('areaCodeSelect');
    if (areaCodeSelect) {
        // Get the default option text from the existing option or use fallback
        const existingDefaultOption = areaCodeSelect.querySelector('option[value=""]');
        const defaultText = existingDefaultOption ? existingDefaultOption.textContent : 'Select Code';
        
        // Try the custom dropdown first, fallback to simple emoji version
        try {
            createCustomCountryDropdown(areaCodeSelect, defaultText);
        } catch (error) {
            console.log('Custom dropdown failed, using simple version:', error);
            populateCountryCodeSelect(areaCodeSelect, defaultText);
        }
    }
});
